export const config = {
  apiUrl: window.location.origin + "/api",
  authUrl: window.location.origin + "/api/auth",
  filesUrl: (key: string) => window.location.origin + "/api/files/" + key,
};
